import axios from 'axios';
import { base_url_api, base_url_api_comunicacao } from '../Utils/baseUrl';

export default axios.create({
  baseURL:base_url_api_comunicacao
});